import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import routes from './routes/'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

function nextFactory(context, middleware, index) {
  const subsecuent = middleware[index];

  if (!subsecuent)
    return context.next;

  return (...parameters) => {
    context.next(...parameters);

    const nextMiddleware = nextFactory(context, middleware, index+1);
    subsecuent({...context, next: nextMiddleware});
  }
}

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  if(nearestWithTitle)
    document.title = nearestWithTitle.meta.title + ' - ' + process.env.VUE_APP_TITLE;

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

    const context = {from, next, router, to};

    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({...context, next: nextMiddleware});
  }

  next();
});

export default router;